/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Documents from './Documents/index'
import FileUploader from 'DesignSystem/FileUploader/react'
import FileUploaderPluginEditor from 'DesignSystem/FileUploaderPluginEditor/react'
import FileUploaderPluginUI from 'DesignSystem/FileUploaderPluginUI/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/Upload/Content",
  restrictions
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let editorApiValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'api',
})
  return (<React.Fragment
>
<FileUploader
  viewPath={`${viewPath}/FileUploader`}
 restrictions={restrictions}
 isOpen={true}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 width={2000}
>
{childProps => (
<React.Fragment>
<FileUploaderPluginEditor
{...childProps}
  viewPath={`${viewPath}/FileUploaderPluginEditor`}
 data="editor.api"
 editor={editorApiValueData}
/>
<FileUploaderPluginUI
{...childProps}
  viewPath={`${viewPath}/FileUploaderPluginUI`}
 name="Images"
 onMount={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Documents/Content'))}
 onUnmount={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Documents/No'))}
>
{childProps => (
<Documents
{...childProps}
  viewPath={`${viewPath}/Documents`}
/>
)}
</FileUploaderPluginUI>
</React.Fragment>
)}
</FileUploader>
{children}
</React.Fragment>)
}